import './Preorders.scss';
import { Button, DataGrid, Form, Tooltip } from 'devextreme-react';
import { Column, Editing, Item, Paging, SearchPanel, Toolbar, Button as Butt, Selection, FilterRow, Pager } from 'devextreme-react/data-grid';
import { AddIcon, filter, CreateOrders, resButtonRefresh, CreateOrdersWhite } from '../../images/icons';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import DataSource from 'devextreme/data/data_source';
import CustomStore from 'devextreme/data/custom_store';
import { useAppDispatch, useAppSelector } from '../../contexts/hooks';
import { setData, setMode } from '../../contexts/slices/preorders';
import { FormPopup, newToast } from '../../components';
import { Item as ItemF } from 'devextreme-react/form';
import ModalCreatePreOrder from './Modals/ModalCreatePreOrder';
import moment from 'moment';
import { useApiPreorders } from '../../api/api.Preorders';
import ConfirmationPopup from '../../components/utils/popup-confirmation/PopupConfirmation';
import { useApiOrders } from '../../api/api.orders';
import { OrderSummary } from '../../types/types.orders';
import { ModalOrdersSummary } from './Modals/ModalOrdersSummary';
import { ModalCreateAppointment } from '../billing/Quotations/Modals/ModalCreateAppointment';
import { ModalReportPreorden } from '../../components/library/reporting/ModalReportPreorden';
import { useApiBarcodes } from '../../api/api.barcodes';
import { SysI_CodBarrasImpresoras } from '../../types/types.barcodes';
import { setModalBarcodePrintersVisible } from '../../contexts/slices/config';
import { useApiAppointments } from '../../api/api.appoiments';

const initialFilters = {
  startDate: moment().format('YYYY-MM-DD'),
  endDate: moment().format('YYYY-MM-DD'),
  //agenda: undefined,
};

type SelectedItem = {
  Usuario?: any; // Cambia `any` por el tipo real de `Usuario` si lo conoces
  [key: string]: any; // Permite otras propiedades dinámicas
};

export default () => {
  const gridRef = useRef<DataGrid>(null);
  const dispatch = useAppDispatch();
  const Prm_Citas_C = useAppSelector((state) => state.userInfo.Permissions?.Prm_Citas_C);
  const ModuleBarcode: boolean = JSON.parse(useAppSelector((x) => x.configuration.Data?.Config_General.filter((x) => x.Cgn_Nombre === 'ModuleBarcode')[0].Cgn_Resultado) || 'false');
  const ModuleSchedule: boolean = JSON.parse(useAppSelector((x) => x.configuration.Data?.Config_General.filter((x) => x.Cgn_Nombre === 'ModuleSchedule')[0].Cgn_Resultado) || 'false');
  const CreateOrderAutomaticInPreorder: boolean = JSON.parse(useAppSelector((x) => x.configuration.Data?.Config_General.filter((x) => x.Cgn_Nombre === 'CreateOrderAutomaticInPreorder')[0].Cgn_Resultado) || 'false');
  const [QuotationData, setQuotationData] = useState<any>(null);
  const [ModalCreateAppointmentVisible, setModalCreateAppointmentVisible] = useState(false);
  const [currentDataDetalle, setCurrentDataDetalle] = useState<any>([]);
  const [modalFiltersVisible, setModalFiltersVisible] = useState(false);
  const [ModalVisible, setModalVisible] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [selectedItems, setSelectedItems] = useState<SelectedItem[]>([]);
  const { GetByFilter, deletePr } = useApiPreorders();
  const { NewOrderFromPreOrders, findOrder } = useApiOrders();
  const [modalConfirmationVisible, setModalConfirmationVisible] = useState(false);
  const [selectedPreordenId, setSelectedPreordenId] = useState<number | null>(null);
  const [visibleReport, setVisibleReport] = useState(false);
  const [dataAgendas, setDataAgendas] = useState<any[]>([]);
  const Prm_CodBarImprimir = useAppSelector((x)=>x.userInfo.Permissions?.Prm_CodBarImprimir);
  const { getAgendas } = useApiAppointments();
  const [currentPrinter, setCurrentPrinter] = useState<SysI_CodBarrasImpresoras | undefined>(undefined);
  const { getPrinters } = useApiBarcodes();
  const [orderSummaryState, setOrderSummaryState] = useState({
    visible: false,
    loading: false,
    data: [] as OrderSummary[],
  });
  const [filters, setFilters] = useState(initialFilters);

  // Estados para datos

  const handleUpdateData = () => {
    setModalFiltersVisible(false);
    fetchData();
  };

  useEffect(() => {
    if (CreateOrderAutomaticInPreorder) {
      getPrinterInfo();
    }

    if (ModuleSchedule) {
      getAgendas().then((res) => {
        setDataAgendas(res);
      });
    }
  }, []);

  const getPrinterInfo = async () => {
    if (!ModuleBarcode) {
      return;
    }
    //Verificar si tenemos en localStorage una impresora configurada.
    const printerData = localStorage.getItem('defaultPrinter');
    let printer: SysI_CodBarrasImpresoras | undefined;
    if (printerData) {
      printer = JSON.parse(printerData);
      setCurrentPrinter(printer);
    } else {
      const printers = await getPrinters();
      if (printers?.length === 0) {
      } else if (printers?.length === 1) {
        localStorage.setItem('defaultPrinter', JSON.stringify(printers[0]));
        printer = printers[0];
        setCurrentPrinter(printer);
        newToast('INFO', `Se ha establecido la impresora '${printer.Cbp_Nombre}' como predeterminada.`, 5);
      } else {
          if(Prm_CodBarImprimir){          
            dispatch(setModalBarcodePrintersVisible(true));
          }
      }
    }
  };

  const handleNewClick = useCallback(() => {
    dispatch(setMode({ mode: 'new' }));
    setCurrentDataDetalle(null);
    setModalVisible(true);
  }, [setModalVisible]);

  const fetchData = useCallback(async () => {
    gridRef.current?.instance?.beginCustomLoading('');
    const result = await GetByFilter(filters);
    gridRef.current?.instance?.endCustomLoading();

    setDataSource(result);
  }, []);

  // useEffect(() => {
  //   fetchData();
  // }, [filters.startDate, filters.endDate, fetchData]);

  const handleModalShowFilter = useCallback(() => {
    setModalFiltersVisible(!modalFiltersVisible);
  }, [modalFiltersVisible]);

  const customDataSrc = useMemo(() => {
    return new CustomStore({
      key: 'POrd_Id',
      load: () =>
        Promise.resolve({
          data: dataSource,
          totalCount: dataSource.length,
        }),
      remove: (key) => {
        return deletePr(key).then((res) => {
          if (res) {
            fetchData();
          }
        });
      },
    });
  }, [dataSource]);

  const customData = useMemo(() => {
    return new DataSource({
      store: customDataSrc,
      reshapeOnPush: true,
    });
  }, [customDataSrc]);

  const handleView = useCallback(
    (e) => {
      dispatch(setData(e.row.data));      
      setCurrentDataDetalle(e.row.data);
      setModalVisible(true);
    },
    [setModalVisible, dispatch]
  );

  const handleClose = useCallback(
    (update: boolean) => {
      if (update) {
        fetchData();
      }
      setModalVisible(false);
    },
    [setModalVisible]
  );

  const handleSelectItems = useCallback(
    (e) => {
      setSelectedItems(e.selectedRowsData);
    },
    [setSelectedItems]
  );

  const handleClicCreateOrders = useCallback(() => {
    if (selectedItems.length === 0) {
      return;
    }
    setModalConfirmationVisible(true);
  }, [selectedItems]);

  const handleConfirmation = useCallback(async () => {
    setModalConfirmationVisible(false);
    const newItems = selectedItems
      .filter((x) => x.POrd_Ord_Id === null)
      .map((item) => {
        // Ya no necesitamos filtrar Usuario y Paciente porque son campos planos
        const { Us_Id, Us_Usuario, Pc_Id, Pc_Identificacion, Pc_Nombre, Pc_Apellido1, Pc_Apellido2, Estudios, ...rest } = item;
        return rest;
      });

    setOrderSummaryState({
      visible: true,
      loading: true,
      data: [],
    });

    const SendData = {
      PreOrders: newItems,
      IdPrinter: currentPrinter?.Cbp_Id,
    };

    NewOrderFromPreOrders(SendData).then((res) => {
      if (res) {
        setOrderSummaryState({
          visible: true,
          loading: false,
          data: res,
        });
      } else {
        setOrderSummaryState({
          visible: true,
          loading: false,
          data: [],
        });
      }
    });
  }, [selectedItems, NewOrderFromPreOrders, setOrderSummaryState]);

  useEffect(() => {
    if (!orderSummaryState.visible) {
      // Reset the selected items when the order summary modal is closed
      gridRef.current?.instance.clearSelection();
      setSelectedItems([]);
      //Actualizamos el grid
      fetchData();
    }
  }, [orderSummaryState.visible]);

  const handleCancelConfirmation = useCallback(() => {
    setModalConfirmationVisible(false);
    gridRef.current?.instance.clearSelection();
  }, []);

  const setLoading = () => {};

  const handleFindOrder = useCallback(
    (e) => {
      if (!e) {
        newToast('WARNING', 'No hay una orden asociada', 5);
        return;
      }
      findOrder(undefined, e, setLoading, true);
    },
    [findOrder]
  );

  const handleCloseModal = useCallback(() => {
    setOrderSummaryState({ ...orderSummaryState, visible: false });
    fetchData();
  }, [setModalVisible]);

  const handleClicCreateAppointment = useCallback(
    (e) => {
      if (!Prm_Citas_C) {
        newToast('WARNING', 'No tienes permisos para crear citas', 3);
        return;
      }
      setQuotationData(e.row.data);
      //console.log(e.row.data);
      setModalCreateAppointmentVisible(true);
    },
    [setModalCreateAppointmentVisible]
  );

  const handleClicPrint = useCallback((e) => {
    const preordenId = e.row.data.POrd_Id;
    // Validar que el ID sea válido
    if (!preordenId) {
      newToast('ERROR', 'No se puede imprimir esta recibo', 4);
      return;
    }

    // Solo establecer el ID, NO sobrescribir dataSource
    setSelectedPreordenId(preordenId);
    setVisibleReport(true);
  }, []);

  // También actualiza el handleCloseModalPrint para limpiar el ID
  const handleCloseModalPrint = useCallback(() => {
    setVisibleReport(false);
    setSelectedPreordenId(null); // ✅ Limpiar el ID al cerrar
  }, []);

  return (
    <div className={'view crm-contact-list'}>
      <div className={'view-wrapper view-wrapper-contact-list'}>
        <DataGrid className='grid' dataSource={customData} ref={gridRef} height='100%' width={'100%'} hoverStateEnabled={true} repaintChangesOnly={true} onSelectionChanged={handleSelectItems} highlightChanges={false} rowAlternationEnabled={true} showColumnLines={true}>
          <Editing allowUpdating={true} allowDeleting={true} />
          <FilterRow visible={true} applyFilter='auto' />
          <SearchPanel visible placeholder='Buscar' />
          <Selection mode='multiple' />
          <Paging enabled={true} />
          <Pager visible={true} allowedPageSizes={[20, 50, 100, 'all']} displayMode='full' showPageSizeSelector={true} showInfo={true} showNavigationButtons={true} />
          <Toolbar>
            <Item location='before'>
              <div className='grid-header'>Preórdenes</div>
            </Item>
            <Item location='after' visible={selectedItems.length > 0} locateInMenu='auto' showText='inMenu' widget='dxButton'>
              <Tooltip target='#toolBarNewOrd' showEvent='mouseenter' hideEvent='mouseleave' position='top'>
                Crear órdenes seleccionadas
              </Tooltip>
              <Button id='toolBarNewOrd' text={'Nuevo'} stylingMode='outlined' icon={CreateOrders} type='success' onClick={handleClicCreateOrders} />
            </Item>
            <Item location='after' visible={selectedItems.length > 0} locateInMenu='auto'>
              <div className='separator' />
            </Item>
            <Item location='after' locateInMenu='auto' showText='inMenu' widget='dxButton'>
              <Tooltip target='#toolBarNew' showEvent='mouseenter' hideEvent='mouseleave' position='top'>
                Nueva preorden
              </Tooltip>
              <Button id='toolBarNew' text={'Nuevo'} stylingMode='outlined' icon={AddIcon} type='success' onClick={handleNewClick} />
            </Item>
            <Item location='after' locateInMenu='auto'>
              <div className='separator' />
            </Item>
            <Item location='after' locateInMenu='auto' showText='inMenu' widget='dxButton'>
              <Tooltip target='.filter-button' showEvent='mouseenter' hideEvent='mouseleave' position='top'>
                Filtrar preórdenes
              </Tooltip>
              <Button className='filter-button' icon={filter} text='Filtrar' stylingMode='text' onClick={handleModalShowFilter} />
            </Item>
            <Item location='after' locateInMenu='auto' showText='inMenu' widget='dxButton'>
              <Tooltip target='.refresh-button' showEvent='mouseenter' hideEvent='mouseleave' position='top'>
                Refrescar datos
              </Tooltip>
              <Button className='refresh-button' icon={resButtonRefresh} text='Actualizar' stylingMode='text' onClick={handleUpdateData} />
            </Item>
            <Item name='searchPanel' locateInMenu='auto' />
          </Toolbar>
          <Column dataField='POrd_Id' caption='NRO.' alignment='center' width={70} />
          <Column
            dataField='POrd_Ord_Id'
            caption='ORDEN'
            width={70}
            alignment='center'
            cellRender={({ data }: { data: any }) => {
              const orderId = data.POrd_Id;
              return (
                <div id={`ord${orderId}`}>
                  <img
                    src={data.POrd_Ord_Id ? CreateOrders : CreateOrdersWhite}
                    alt='Orden'
                    onClick={() => {
                      handleFindOrder(data.POrd_Ord_Id);
                    }}
                  />
                  <Tooltip target={`#ord${orderId}`} showEvent='mouseenter' hideEvent='mouseleave' position='top'>
                    {data.POrd_Ord_Id ? `Ver orden` : 'No hay orden asociada'}
                  </Tooltip>
                </div>
              );
            }}
          />

          <Column dataField='POrd_FechaCreacion' caption='FECHA' dataType='datetime' format='dd/MM/yyyy' alignment='left' width={100} />
          <Column dataField='Pc_Identificacion' caption='DOCUMENTO' alignment='center' width={150} />
          <Column
            dataField='Paciente'
            cellRender={handlePatientCellRender}
            calculateCellValue={(rowData) => {
              const { Pc_Nombre, Pc_Apellido1, Pc_Apellido2 } = rowData;
              return `${Pc_Nombre} ${Pc_Apellido1 || ''} ${Pc_Apellido2 || ''}`.trim();
            }}
            minWidth={200}
            caption='PACIENTE'
            alignment='left'
          />
          <Column dataField='Us_Usuario' caption='CREADO POR' alignment='center' width={150} />
          <Column
            dataField='Estudios'
            caption='EXÁMENES'
            alignment='left'
          />

          <Column type='buttons' caption={'ACCIÓN'} width={120}>
            <Butt icon='eyeopen' text='Ver' onClick={handleView} />
            <Butt icon='custom-date' text='Crear cita' onClick={handleClicCreateAppointment} />
            <Butt icon='print' text='Imprimir' hint='Imprimir recibo' onClick={handleClicPrint} />
            <Butt name='delete' text='Eliminar' />
          </Column>
        </DataGrid>
      </div>
      {modalFiltersVisible && (
        <FormPopup title='Filtrar cotizaciones' visible={modalFiltersVisible} setVisible={handleModalShowFilter} onSave={handleUpdateData} loading={false} allowSave={false}>
          <Form formData={filters} labelLocation='left' className='plain-styled-form'>
            <ItemF dataField='startDate' editorType='dxDateBox' label={{ text: 'Fecha inicial' }} />
            <ItemF dataField='endDate' editorType='dxDateBox' label={{ text: 'Fecha final' }} />
            {ModuleSchedule && (
              <ItemF
                dataField='lstAgendas'
                editorType='dxTagBox'
                label={{ text: 'Agenda asignada a' }}
                editorOptions={{
                  dataSource: dataAgendas,
                  displayExpr: 'Ag_Nombre',
                  valueExpr: 'Ag_Id',
                  showSelectionControls: true,
                  showClearButton: true,
                  placeholder: 'Seleccione una o varias agendas',
                  maxDisplayedTags: 1,
                  applyValueMode: 'useButtons',
                  searchEnabled: true,
                }}
              />
            )}
          </Form>
        </FormPopup>
      )}
      {ModalCreateAppointmentVisible && <ModalCreateAppointment visible={ModalCreateAppointmentVisible} setVisible={setModalCreateAppointmentVisible} quotationId={QuotationData ? QuotationData.Cz_Id : -1} patientDocument={QuotationData ? QuotationData.Pc_Identificacion : ''} patientId={QuotationData ? QuotationData.Pc_Id : -1} preorderId={QuotationData ? QuotationData.POrd_Id : -1} />}
      <ModalReportPreorden visible={visibleReport} setVisible={handleCloseModalPrint} reportName='Preordenes' idPreorden={selectedPreordenId ? selectedPreordenId : -1} />
      {ModalVisible && <ModalCreatePreOrder visible={ModalVisible} setVisible={handleClose} currentData={currentDataDetalle} idPreOrder={currentDataDetalle ? currentDataDetalle.POrd_Id : -1} />}
      {modalConfirmationVisible && <ConfirmationPopup visible={modalConfirmationVisible} onConfirm={handleConfirmation} onCancel={handleCancelConfirmation} message={`Se crearán ${selectedItems.filter((x) => x.POrd_Ord_Id === null).length} órdenes, desea continuar`} />}
      {orderSummaryState.visible && <ModalOrdersSummary visible={orderSummaryState.visible} loading={orderSummaryState.loading} data={orderSummaryState.data} onClose={handleCloseModal} />}
    </div>
  );
};

const handlePatientCellRender = (data: any) => {
  const { Pc_Nombre, Pc_Apellido1, Pc_Apellido2 } = data.data;
  return (
    <div>
      {Pc_Nombre} {Pc_Apellido1 || ''} {Pc_Apellido2 || ''}
    </div>
  );
};